import React, { FC, useEffect, useState } from "react";
import { useField } from "formik";
import PhoneInput, { CountryData } from "react-phone-input-2";
import "react-phone-input-2/lib/high-res.css";
import style from "./style.module.scss";
import validationError from "../../assets/images/validationError.svg";
import de from "react-phone-input-2/lang/de.json";

interface IPhoneInput {
  name: string;
  type: string;
  label: string;
  isDisabled?: boolean;
  width?: string;
}

export const CustomPhoneInput: FC<IPhoneInput> = ({
  name,
  type,
  label,
  isDisabled = false,
  width,
}: IPhoneInput) => {
  const [country, setCounty] = useState("Deutschland");
  const [field, meta, helpers] = useField({
    name,
    type,
  });

  useEffect(() => {
    const flag = document.getElementsByClassName("flag")[0];

    if (flag) {
      flag.setAttribute("role", "img");
      flag.setAttribute("aria-label", `${country}-Flagge`);
    }
  }, [country]);

  return (
    <div
      className={`${style.input_wrapper}
        ${meta.touched && meta.error ? style.input_wrapperWithWarning : ""}
        `}
      style={{
        opacity: isDisabled ? 0.5 : 1,
        width: width ? width : "",
      }}
    >
      <label
        className={`${style.label} ${
          meta.touched && meta.error && !isDisabled && style.labelWithWarning
        }`}
        htmlFor={name}
      >
        {label}
      </label>
      <PhoneInput
        country={"de"}
        localization={de}
        value={!field.value ? "" : field.value}
        disabled={isDisabled}
        onChange={(value, data) => {
          if (isDisabled) {
            return;
          }
          if ((data as CountryData) && (data as CountryData).name) {
            setCounty((data as CountryData).name);
          }
          helpers.setValue(value);
        }}
        inputClass={`${style.phoneInput_wrapper}  ${
          isDisabled ? style.disabledCustomInput : ""
        } ${
          meta.touched &&
          meta.error &&
          !isDisabled &&
          style.customInputWithWarning
        }`}
        containerClass={style.customContainer}
        buttonClass={`${style.customBtn} ${
          meta.touched && meta.error && style.customBtnWithError
        }`}
        dropdownClass={style.dropdown}
        onBlur={field.onBlur}
        inputProps={{
          name: name,
          type: type,
          "aria-label": "Ländervorwahl auswählen",
          id: name,
        }}
      />
      {meta.touched && meta.error && !isDisabled && (
        <div className={style.errorMessage}>{meta.error}</div>
      )}
      {meta.touched && meta.error && !isDisabled && (
        <img
          src={validationError}
          alt="err"
          className={`${style.warningImg}`}
        />
      )}
    </div>
  );
};
